export default __webpack_public_path__ + "static/media/bitbucket.dd613b95.svg";